import { render, staticRenderFns } from "./CreditNotesDialog.vue?vue&type=template&id=3b02e8a2&scoped=true&"
import script from "./CreditNotesDialog.vue?vue&type=script&lang=js&"
export * from "./CreditNotesDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreditNotesDialog.vue?vue&type=style&index=0&id=3b02e8a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b02e8a2",
  null
  
)

export default component.exports